import { eula } from '../../../mocks/CreateEnvironment';
import { EULADetails } from '../../../types/workflows/steps/Eula';

export default class EulaStepAPI {
  public static getEula = (): Promise<EULADetails> => {
    return Promise.resolve({ eula });
  }
}
